export default class InputTime {

	static getTimeStyle() {
		const timeStyle = {
			"height": "calc(1.5em + 0.5rem + 2px)",
			"padding": "0.25rem 0.5rem",
			"fontSize": "0.875rem",
			"lineHeight": "1.5",
			"borderRadius": "0.2rem",
			"fontWeight": "400",
			"display": "block",
			"color": "#495057",
			"backgroundColor": "#fff",
			"backgroundClip": "padding-box",
			"border": "1px solid #ced4da",
			"width": "100%"
		}

		return timeStyle;
	}
}
